import {Injectable, EventEmitter} from '@angular/core';
import {UserSession, HttpOptions} from "../modele/authModel";
import {NGXLogger} from "ngx-logger";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DelayService {
    private current_user_session:UserSession = new UserSession();
    private user_session_is_ready_emitter:EventEmitter<boolean> = new EventEmitter();
    private session_is_ready:boolean = false;
    private local_http_opts:HttpOptions= new HttpOptions();

    private log_prefix="DelayService:";
    constructor(
        private logger: NGXLogger,
    ) {
        // this.authService.getLogInStateEmitter().subscribe(logInState => {
        //     if (logInState == true) {
        //         this.authService.getUserSessionViaObservable().subscribe((userSession) => {
        //             this.current_user_session = new UserSession({
        //                 token: userSession.token,
        //                 expire: userSession.expire,
        //                 ttl: userSession.ttl
        //             });
        //             this.session_is_ready=true;
        //             this.user_session_is_ready_emitter.emit(true);
        //         })
        //     }
        // });
    }
    public getSessionIsReadyEmitter(){
        return this.user_session_is_ready_emitter;
    }
    public checkIfSessionIsReady():boolean{
        return this.session_is_ready;
    }

    public waitForSessionStart():Observable<boolean>{
        return new Observable((observer)=>{
            return observer.next(this.session_is_ready);
        })
    }
    public waitForUserSession():Observable<UserSession>{
        return new Observable((observer)=>{
            return observer.next(this.current_user_session);
        })
    }
    public waitForHttpOpts():Observable<HttpOptions>{
        return new Observable((observer)=>{
            // this.local_http_opts = this.authService.setupHttpOpts(this.current_user_session);
            return observer.next(this.local_http_opts);
        })
    }
}
